export const generalDatesFormat = 'DD-MM-YYYY'; // 'YYYY-MM-DD'
export const generalDatesHoursFormat = 'DD-MM-YYYY hh:mm A'; // 'YYYY-MM-DD'
export const GoogleMapsApiKey = 'AIzaSyDZ9WNaRU_WYIk3PLqLJCyPts7bTr8yg2Q';


export const defaultBoxesPerPallet = 240; // over 90% of orders are packed the same so this default value is used